import React, { Component, Fragment } from "react";
import "./CorsairsTreasure.scss"
import Slotsanimation from "../Slotanimation/SlotsAnimation"
import WinningAmount from "../Animations/winningAmt/winningamt"
import WinLines from "../Animations/DrawLine_Win_Animation/WinLines";
import WinPulse from "../Animations/WinningPulseAn/WinPulse"
import WinBGColor from "../Animations/WinBGColor/WinBGClr"
import FreeSpins from "../Animations/freespins/FreeSpins"
import BonusAnimate from "../CorsairsTreasure/bonus/BonusAnimate"

import chip_10 from "../../../../../assets/games/russianPoker/black.png";
import chip_25 from "../../../../../assets/games/russianPoker/Purple chip.svg";
import chip_50 from "../../../../../assets/games/russianPoker/blue.png";
import chip_100 from "../../../../../assets/games/russianPoker/red.png";
import chip_500 from "../../../../../assets/games/russianPoker/yellow.png";
import chip_1000 from "../../../../../assets/games/russianPoker/Whitechip.svg"
import betincerementdecrement from "../../../../../assets/games/slots/Corsairs_Treasure/Asset 9r.svg";
import circlechip from "../../../../../assets/games/slots/Retrotech/chipCircle.png";
import spinbtn from "../../../../../assets/games/slots/Corsairs_Treasure/Asset 2.png";
import AutoPlayBtn from "../../../../../assets/games/slots/Corsairs_Treasure/Asset 4.png";

import bet from "../../../../../assets/games/slots/Corsairs_Treasure/Asset 1.png"
import logo from "../../../../../assets/games/slots/Corsairs_Treasure/Asset 11.png"
// import win from "../../../../../assets/games/slots/Corsairs_Treasure/Asset 4.png"
// import balance from "../../../../../assets/games/slots/Corsairs_Treasure/Asset 4.png"

import win from "../../../../../assets/games/slots/CommanAssets/win_icon.png"
import balance from "../../../../../assets/games/slots/CommanAssets/coins_bln.png"

import closeBtn from "../../../../../assets/games/slots/Corsairs_Treasure/Asset 7.png"

import menu from '../../../../../assets/games/slots/Corsairs_Treasure/Asset 5.png';
import Chips from "../../../../../library/Chips/Chips";

import BGFF from '../../../../../assets/games/slots/Corsairs_Treasure/Asset 9.svg';
import Frame from '../../../../../assets/games/slots/Corsairs_Treasure/Asset 10.png';
import i_icon from '../../../../../assets/games/slots/Corsairs_Treasure/pay_icon.png';
import mute_sound from '../../../../../assets/games/slots/Corsairs_Treasure/No-Volume.png';
import Valume from '../../../../../assets/games/slots/Corsairs_Treasure/Volume.png';

import profile from '../../../../../assets/games/slots/CommanAssets/userid.png';

import Mobile_Frame from '../../../../../assets/games/slots/Corsairs_Treasure/Mobile_Frame.png';
// ICON imports...

import img0 from '../../../../../assets/games/slots/Corsairs_Treasure/Corsairs-treasure-00.png';
import img1 from '../../../../../assets/games/slots/Corsairs_Treasure/Corsairs-treasure-01.png';
import img2 from '../../../../../assets/games/slots/Corsairs_Treasure/Corsairs-treasure-02.png';
import img3 from '../../../../../assets/games/slots/Corsairs_Treasure/Corsairs-treasure-03.png';
import img4 from '../../../../../assets/games/slots/Corsairs_Treasure/Corsairs-treasure-04.png';
import img5 from '../../../../../assets/games/slots/Corsairs_Treasure/Corsairs-treasure-14.png';
import img6 from '../../../../../assets/games/slots/Corsairs_Treasure/Corsairs-treasure-06.png';
import img7 from '../../../../../assets/games/slots/Corsairs_Treasure/Corsairs-treasure-07.png';
import img8 from '../../../../../assets/games/slots/Corsairs_Treasure/Corsairs-treasure-08.png';
import img9 from '../../../../../assets/games/slots/Corsairs_Treasure/Corsairs-treasure-09.png';

import CorsairsPayOuttable from "./CorsairsPayout/CorsairsPayout";
import HistoryTable from "../history/History";

import Howlersounds from "../../../../js/Utillitys/slotshowlersounds"
import { connect } from "react-redux";




class CorsairsTreasure extends Component {
    payoutlist = [
        { linesCount: 1, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 1, 1, 1, 1], clr: "#fa7705" }, // 1
        { linesCount: 2, backGroung_G_clr: ['#687ced', '#9c0983'], active: true, payoutLine: [0, 0, 0, 0, 0], clr: "#05fa36" }, // 2
        { linesCount: 3, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [2, 2, 2, 2, 2], clr: "#fa7705" }, // 3
        { linesCount: 4, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [0, 1, 2, 1, 0], clr: "#ffff" }, // 4
        { linesCount: 5, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [2, 1, 0, 1, 2], clr: "#0c28b3" }, // 5
        { linesCount: 6, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 0, 1, 2, 1], clr: "salmon" }, // 6
        { linesCount: 7, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 2, 1, 0, 1], clr: "skyblue" }, // 7
        { linesCount: 8, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [0, 1, 0, 1, 0], clr: "red" }, // 8
        { linesCount: 9, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [2, 1, 2, 1, 2], clr: "firebrick" }, // 9
    ]
    HistoryData = []
    GamesRules = [
        {
            "rules": "Game Big Bass Treasure is a 5-reel slot with 9 pay lines and bonus game, that allows to increase the winning."
        },
        {
            "rules": "At first choose the bet amount on the line, using switches in the field Line Bet."
        },
        {
            "rules": "Then set number of paylines using switches in the field Lines or by clicking on the corresponding number."
        },
        {
            "rules": "To launch the game with fixed bet use button Spin."
        },
        {
            "rules": "To launch the game with the maximum lines use button Bet Max."
        },
        {
            "rules": "To enable the automatic game mode push button AutoPlay, set the number of spins in the opened dialog (5,10, 25, 50) and push button Play. The game will automatically launch the preset number of times with the bet of the previous round."
        },
        {
            "rules": "The reel lines, engaged in the game, are checked for the presence of winning combinations after the stop."
        },
        {
            "rules": "The combination is considered to be winning if it begins from the left-most reel, i.e. symbols of similar denomination should be set in a line from left to right"
        },
        {
            "rules": "The combination that has the maximum value wins in the line. Winning combinations are paid according to the payout table."
        },
        {
            "rules": "At the combination of three or more symbols Wheel in any place on paid line, a bonus game is launched. The bonus game allows increasing bet per line for several times."
        },
        {
            "rules": "If several paylines contain the bonus combination, then the winning in bonus game is multiplied by bet sum of all lines that have bonus combination."
        },
        {
            "rules": " The player is taken to a new screen showing 4 Treasure Boxes."
        },
        {
            "rules": " Each box may contain: A reward (bonus amount), or No reward (empty box)."
        },
        {
            "rules": " The player can select only one box."
        },
        {
            "rules": "If the box contains a prize, the reward is added to the player’s total win."
        },
        {
            "rules": "If the selected box is empty, the bonus round ends with no additional reward."
        }
    ]

    constructor(props) {
        super(props);
        this.state = {
            win_amount: 0,
            betchipincrementbtn: false,
            count: 1,
            betdecreamentbtn: false,
            anteamount: 1,
            chipcount: 1,
            TotalBalance: this.props.balance,
            winAMT: 0,
            gamewins: false,
            linescount: 9,
            showAutoPlayOptions: false,
            autoPlayOptions: [5, 10, 25, 50],
            autoPlayCount: 0,
            isAutoPlay: false,
            showCancelAutoPlay: false,
            prevAutoCount: 0,
            PayoutTableShow: false,
            drawnLinesT: false,
            drawnLinesresDate: [],
            isSpinning: true,
            UpdatedPayoutList: [],

            payoutpayoutpopup: false,
            menuActive: false,
            ErrorPopup: false,
            WinPulseRT: false,
            WinBGColorsRT: false,
            IndexWinningIcons: [],
            freeSpinsPopup: false,
            FreeSpinsBonus: 'Bonus',
            BonusAnimateActive: false,
            historyTablePopup: false,
            mutesounds: false,
            BetResponseCT: [],
            mute_images: Valume,
            GameRulesPopup: false,
            ErrorMsg: '',
            ErrorMsgHead: '',
            BonusActiveStatus: false,
            gameStatus: false,
            turboActive: false
        }
        this.updatePlayerInfo = this.updatePlayerInfo.bind(this);
        this.setWinsAndAmount = this.setWinsAndAmount.bind(this);
        this.getGameState = this.getGameState.bind(this);
        this.chipVal = [
            { src: chip_10, key: 1, label: "10", val: 10 },
            { src: chip_25, key: 2, label: "20", val: 20 },
            { src: chip_50, key: 3, label: "50", val: 50 },
            { src: chip_100, key: 4, label: "100", val: 100 },
            { src: chip_500, key: 5, label: "500", val: 500 },
            { src: chip_1000, key: 6, label: "1000", val: 1000 },
        ];

        this.Slotsanimation = React.createRef();
        this.SideMenuRef = React.createRef();
        this.paylines = [
            { id: 1, positions: [1, 1, 1, 1, 1] },      // Middle row
            { id: 2, positions: [0, 0, 0, 0, 0] },      // Top row
            { id: 3, positions: [2, 2, 2, 2, 2] },      // Bottom row
            { id: 4, positions: [0, 1, 2, 1, 0] },      // V shape
            { id: 5, positions: [2, 1, 0, 1, 2] },
            // Inverted V
            { id: 6, positions: [0, 0, 1, 0, 0] },      // Zigzag
            { id: 7, positions: [2, 2, 1, 2, 2] },      // Zigzag reverse
            { id: 8, positions: [1, 0, 0, 0, 1] },      // small peak
            { id: 9, positions: [1, 2, 2, 2, 1] },
        ];
        this.cellSize = 40;
        this.rows = 3;
        this.cols = 5;
        this.activeColor = "#47a59c"; // 🔹 Aqua-blue
        this.inactiveColor = "#070707b4"; // 🔹 Dark
        this.lineColor = "#e6c408ff"; // line inside selected

        this.Game_Icons = {
            img0, img1, img2, img3, img4, img5, img6,
            img7, img8, img9
        };
        this.Game_Icons_dummy = {
            img0, img1, img2, img3, img4, img5, img6,
            img7, img8, img9
        };

        this.CreateBG = new Image();
        this.CreateBG.src = BGFF
        this.Howlersounds = React.createRef();
        this.BonusAnimateRef = React.createRef();

    }
    componentDidMount() {

        document.getElementById('iospopup').style.display = "block";
        this.Howlersounds.current?.playSound("backgroundSoundS");
        this.Slotsanimation.current.GameImgs(this.Game_Icons, this.Game_Icons_dummy)
        document.addEventListener('click', this.handleDocumentClick);
        this.handleImageLoad()

        const { childRef } = this.props;
        childRef(this);
        this.setState({
            UpdatedPayoutList: this.payoutlist
        })
        console.log(this.props.balance)
        this.setState({
            TotalBalance: this.props.balance,
            anteamount: Number(this.props.os_chipValues.split(",")[0]) * Number(this.state.linescount)
        })
        // let increamentchip = document.getElementById("betincrenetTP")
        // let decreamentchip = document.getElementById("betdecrementTP")

        // increamentchip.src = betincerementdecrement
        // decreamentchip.src = betincerementdecrement
        console.log(this.chipVal, this.props.os_chipValues)
        this.chipVal = this.props.os_chipValues.split(",").map((ele, ind) => ({ val: ele, chipindex: ind + 1 }));
        console.log(this.props.gameState);

        if (this.props.gameState.response) {
            if (this.props.gameState?.response?.bonuscount > 0) {
                if (this.props.gameState.response.gameFinished == false) {
                    this.setState({
                        freeSpinsPopup: true,
                        BonusActiveStatus: true
                    })
                }
            } else {
                this.setState({
                    isSpinning: false
                })
            }
        }

        if (this.props.gameState) {
            this.SpinControlDis(false)
            this.checkHistoryData()
            this.setState({
                gameStatus: true
            })
        }
    }

    updatePlayerInfo() {
        console.log("enter")
        console.log(this.props.balance)
        this.setState({
            TotalBalance: this.props.balance,
            // win_amount: 0
        })
    }

    UpdateplayerinfoPlayerWins(res) {
        console.log("Updated enter")
        console.log(res)
        console.log(this.props.balance)
        this.setState({
            TotalBalance: res.balance,
            // win_amount: 0
        })
    }
    checkGameState = (res) => {
        console.log(res, this.state.autoPlayCount)

        //Auto Play
        if (res.handId !== res.oldHandId && this.state.autoPlayCount && this.state.isAutoPlay) {
            if (this.state.showCancelAutoPlay) {

            } else {
                setTimeout(() => {
                    this.spinaction()
                }, 1000)
            }
        } else if (this.state.isAutoPlay && !this.state.autoPlayCount) {
            this.setState({ isAutoPlay: false })
        } else {
            this.stopAutoPlayGameState()
        }

        if (res.response) {
            if (res.response?.bonuscount > 0) {
                // if (res.response.action == "MOVE_BET") {
                if (res.response.gameFinished == false) {
                    this.setState({
                        freeSpinsPopup: true,
                        BonusActiveStatus: true
                    })
                }
            } else {
                if (res.response.gameFinished) {
                    this.setState({
                        freeSpinsPopup: false,
                        BonusActiveStatus: false
                    })
                }
            }
            this.setState({
                gameStatus: true
            })
            this.SpinControlDis(false)
            this.checkHistoryData()
        }

    }
    spinaction = (body) => {
        this.Howlersounds.current?.playSound("clickbtnS");
        this.setState({ win_amount: 0 })
        console.log(this.state.chipcount)
        if (this.state.anteamount <= this.state.TotalBalance &&
            this.state.chipcount >= this.props.minBetAmt &&
            this.state.chipcount <= this.props.maxBetAmt) {

            this.setState({
                drawnLinesT: false,
                WinPulseRT: false,
                WinBGColorsRT: false,
                drawnLinesresDate: []
            })
            let SlotsBody = {
                sessionId: sessionStorage.getItem("sessionId"),
                CN: "CORSAIRS_TREASURE_BET",
                object: {
                    action: "PARAM_BET",
                    gameId: this.props.gameId,
                    playerId: Number(this.props.playerId),
                    handId: Number(this.props.gameState.handId),
                    linesCount: Number(this.state.linescount),
                    coin: Number(this.state.chipcount),
                    coinCount: 1,
                    betAmount: Number(this.state.chipcount) * Number(this.state.linescount)
                }
            }
            this.setState({
                TotalBalance: this.props.balance
            })
            console.log(this.state.TotalBalance)
            console.log(this.state.anteamount)
            // this.setState({
            //     TotalBalance: Number(Number(this.state.TotalBalance) - Number(this.state.anteamount)).toFixed(2)
            // })
            console.log(this.state.TotalBalance)
            console.log(SlotsBody)
            this.props.network.sendof(SlotsBody);
            this.setState({
                isSpinning: true,
                gameStatus: false
            })

            this.Slotsanimation.current.setTurboMode(this.state.turboActive);

        } else {

            if (this.state.anteamount > this.state.TotalBalance) {
                this.setState({
                    ErrorPopup: true,
                    ErrorMsg: "You have insufficient balance for the bet.",
                    ErrorMsgHead: "insufficient balance!"
                })
            } else if (this.state.chipcount < this.props.minBetAmt) {
                this.setState({
                    ErrorPopup: true,
                    ErrorMsg: `Minimum bet should be ${this.props.minBetAmt}.`,
                    ErrorMsgHead: "Min Bet Error!"
                });
            } else if (this.state.chipcount > this.props.maxBetAmt) {
                this.setState({
                    ErrorPopup: true,
                    ErrorMsg: `Maximum bet allowed is ${this.props.maxBetAmt}.`,
                    ErrorMsgHead: "Max Bet Error!"
                });
            }
        }
    }

    getGameState = () => {
        if (this.state.BonusActiveStatus) {

        } else {
            this.props.gamstateHandle();
            this.updateplayerbalnace()
            this.setState({
                gameStatus: false
            })
        }
    }

    IncreamentBetchips = () => {
        this.Howlersounds.current?.playSound("clickbtnS");
        if (this.state.count < this.chipVal.length) {
            this.setState(
                (prevState) => ({
                    count: prevState.count + 1,
                }),
                () => {
                    console.log(this.chipVal[this.state.count - 1].val)
                    this.setState({
                        anteamount: Number(this.chipVal[this.state.count - 1].val) * Number(this.state.linescount),
                        // anteamount: this.chipVal[this.state.count - 1].val ,
                        chipcount: this.chipVal[this.state.count - 1].val
                    })
                    if (this.state.count > 6) {
                        this.setState({ betchipincrementbtn: true, betdecreamentbtn: false });

                    }
                    else {
                        this.setState({ betchipincrementbtn: false });
                    }
                    // this.betChipsIncrementDecremenAction()
                    console.log(this.state.anteamount)
                })
        }
        console.log(this.state.count)

    };

    DecreamentBetchips = () => {
        this.Howlersounds.current?.playSound("clickbtnS");
        if (this.state.count > 1) {
            this.setState(
                (prevState) => ({
                    count: prevState.count - 1,
                }),
                () => {
                    console.log(this.chipVal[this.state.count - 1].val)
                    this.setState({
                        anteamount: Number(this.chipVal[this.state.count - 1].val) * Number(this.state.linescount),
                        // anteamount: this.chipVal[this.state.count - 1].val ,
                        chipcount: this.chipVal[this.state.count - 1].val
                    })

                    if (this.state.count < 1) {
                        this.setState({ betdecreamentbtn: true, betchipincrementbtn: false });
                    } else {
                        this.setState({ betdecreamentbtn: false });
                    }

                    //   this.betChipsIncrementDecremenAction();

                }
            );
        }
        console.log(this.state.count)
    };

    CorsairsTreasureBetRes = (res) => {
        this.setState({
            BetResponseCT: res
        })
        console.log(res)
        // let winningLines = res.lines
        let fixed = res.datanew.replace(/([{,])\s*(\w+)\s*:/g, '$1"$2":')
        let arrayCT = JSON.parse(fixed);
        let pulseIndexs = []
        arrayCT.map((resReels, index) => {
            console.log(resReels)
            console.log(resReels.line)
            console.log(res.winninglines)
            console.log(res.winninglines[index])
            let winline = res.winninglines[index]
            let smallarray = [];
            for (let i = 0; i < winline.length; i++) {
                if (res?.board[i][winline[i]] == resReels?.symbol || res?.board[i][winline[i]] == 8) {
                    console.log(res?.board[i][winline[i]], resReels?.symbol)
                    smallarray.push(i)
                } else {
                    break;

                }
            }
            pulseIndexs.push(smallarray)
            console.log(pulseIndexs)

            // this.setState({
            //     IndexWinningIcons: pulseIndexs
            // })
        })

        console.log(pulseIndexs)
        console.log(pulseIndexs[pulseIndexs.length - 1])
        console.log(arrayCT);

        // setTimeout(() => {
        //     this.setState({ win_amount: res.winAmount })
        // }, 2000)

        this.Slotsanimation.current.spinofcheck(res.board, res.winninglines, res.winAmount, pulseIndexs)
        this.Howlersounds.current?.playSound("spinStartS");

    }

    CorsairsTreasureBonusRes = (res) => {
        console.log(res)
        console.log("///////////////////////////////////////////////////////////////")
        this.setState({
            BetResponseCT: res
        })
        if (res?.action == "MOVE_BET") {
            let winAmountBouns = res?.bonusWinAmount
            this.BonusAnimateRef.current?.WinsBonusBoxOpen(winAmountBouns)
            this.setState({ win_amount: res.winAmount })
        }
    }

    Increamentlinescount = () => {
        this.Howlersounds.current?.playSound("clickbtnS");
        this.setState(
            (prevState) => ({
                linescount: Math.min(prevState.linescount + 1, 9),
                anteamount: Number(this.chipVal[this.state.count - 1].val) * Math.min(prevState.linescount + 1, 9),
            }),
            () => {
                this.setNewActiveLines('INC')
            }
        );
    };

    Decreamentlinescount = () => {
        this.Howlersounds.current?.playSound("clickbtnS");
        this.setState(
            (prevState) => ({
                linescount: Math.max(prevState.linescount - 1, 1),
                anteamount: Number(this.chipVal[this.state.count - 1].val) * Math.max(prevState.linescount - 1, 1),
            }),
            () => {
                this.setNewActiveLines('DEC')
            }
        );
    };

    setWinsAndAmount = (winAmount) => {
        this.setState({
            gamewins: Boolean(winAmount),
            winAMT: winAmount,
        })

        if (!winAmount) {
            this.setState((prevState) => ({
                ...prevState,
                autoPlayCount: prevState.autoPlayCount > 0 ? prevState.autoPlayCount - 1 : 0
            }), () => {
                console.log(this.state.BetResponseCT)
                if (this.state.BetResponseCT?.bonuscount > 0) {
                    this.AfterSpinHit()
                } else {
                    this.getGameState()
                    // this.setState({
                    //     BetResponseCT: []
                    // })
                }
            })
        } else {
            this.Howlersounds.current?.playSound("scatterWinS");
            this.Howlersounds.current?.playSound("bonusWin");
            this.setState({ win_amount: winAmount })
        }
    }


    handleAutoPlayClick = () => {
        this.Howlersounds.current?.playSound("clickbtnS");
        const { autoPlayCount, isAutoPlay } = this.state;

        if (!autoPlayCount) {
            // Case 1: No count yet → open options
            this.setState({ showAutoPlayOptions: true });
        } else if (isAutoPlay) {
            // Case 2: Already auto playing → stop
            this.setState((prevState) => ({ ...prevState, isAutoPlay: true, showCancelAutoPlay: true, prevAutoCount: prevState.autoPlayCount }));
            // this.setState((prevState) => ({ ...prevState, autoPlayCount: 0, isAutoPlay: true, showCancelAutoPlay: true, prevAutoCount: prevState.autoPlayCount }));
        } else {
            // Case 3: Not playing → start
            if (Number(this.state.anteamount) * Number(autoPlayCount) <= this.state.TotalBalance &&
                this.state.chipcount >= this.props.minBetAmt &&
                this.state.chipcount <= this.props.maxBetAmt) {
                this.setState({ isAutoPlay: true, showAutoPlayOptions: false, showCancelAutoPlay: false }, () => {
                    this.spinaction()
                });

            } else {
                this.setState({
                    showAutoPlayOptions: false
                })
                this.stopAutoPlayGameState()
                if (Number(this.state.anteamount) * Number(autoPlayCount) > this.state.TotalBalance) {
                    this.setState({
                        ErrorPopup: true,
                        ErrorMsg: "You have insufficient balance for the AutoPlay.",
                        ErrorMsgHead: "insufficient balance!"
                    })
                } else if (this.state.chipcount < this.props.minBetAmt) {
                    this.setState({
                        ErrorPopup: true,
                        ErrorMsg: `Minimum bet should be ${this.props.minBetAmt}.`,
                        ErrorMsgHead: "Min Bet Error!"
                    });
                } else if (this.state.chipcount > this.props.maxBetAmt) {
                    this.setState({
                        ErrorPopup: true,
                        ErrorMsg: `Maximum bet allowed is ${this.props.maxBetAmt}.`,
                        ErrorMsgHead: "Max Bet Error!"
                    });
                }
            }
        }
    };

    stopAutoPlayGameState = () => {
        this.Howlersounds.current?.playSound("clickbtnS");
        this.setState({ autoPlayCount: 0, isAutoPlay: false, showCancelAutoPlay: false });
    }
    stopAutoPlay = () => {
        this.Howlersounds.current?.playSound("clickbtnS");
        this.setState({ autoPlayCount: 0, isAutoPlay: false, showCancelAutoPlay: false });
        if (this.state.gameStatus) {
            this.setState({
                isSpinning: false
            })
        }
    }

    restartAutoPlay = () => {
        this.Howlersounds.current?.playSound("clickbtnS");
        this.setState((prevState) => ({ ...prevState, autoPlayCount: prevState.prevAutoCount - 1, showCancelAutoPlay: false, isAutoPlay: false }), () => {
            this.handleAutoPlayClick()
        })
    }
    OpenPayoutTable = () => {
        this.Howlersounds.current?.playSound("clickbtnS");
        this.setState({
            PayoutTableShow: true
        })
    }
    ClosePayoutTable = () => {
        this.Howlersounds.current?.playSound("clickbtnS");
        this.setState({
            PayoutTableShow: false
        })
    }

    CreateRetroLines = (data) => {
        let ctx = data.ctx
        // this.drawIconBackground(ctx, data.x, data.y, data.ICON_WIDTH, data.ICON_HEIGHT)
        this.drawIconBackgroundImg(ctx, data.x, data.y, data.ICON_WIDTH, data.ICON_HEIGHT)
    }
    CreateWinAnimationsData = (data) => {
        // console.log(data)
        this.setState({
            drawnLinesT: true,   // Enable draw lines
            WinPulseRT: true,   // Enable pulse
            // WinBGColorsRT: true,   // Enable BGColor && Pulse
            drawnLinesresDate: data
        })

    }

    drawIconBackground = (ctx, x, y, width, height) => {
        const margin = 0;         // spacing between slots
        const cornerRadius = 25;   // smooth corners
        console.log(x)
        console.log(y)
        console.log(width)
        console.log(height)
        const innerX = x + margin / 2;
        const innerY = y + margin / 2;
        const innerW = width - margin;
        const innerH = height - margin;

        // Main orange-yellow gradient background
        const baseGradient = ctx.createLinearGradient(innerX, innerY, innerX + innerW, innerY + innerH);
        baseGradient.addColorStop(0, "#FFB300");
        baseGradient.addColorStop(0.5, "#FFD640");
        baseGradient.addColorStop(1, "#FF7A00");

        ctx.fillStyle = baseGradient;
        ctx.beginPath();
        ctx.roundRect(innerX, innerY, innerW, innerH, cornerRadius);
        ctx.fill();

        // Inner light glow (bright center)
        const cx = innerX + innerW / 2;
        const cy = innerY + innerH / 2;
        const r = Math.min(innerW, innerH) / 1.2;
        const glow = ctx.createRadialGradient(cx, cy, 0, cx, cy, r);
        glow.addColorStop(0, "rgba(255, 255, 180, 0.9)");
        glow.addColorStop(0.3, "rgba(255, 210, 80, 0.6)");
        glow.addColorStop(0.7, "rgba(255, 160, 0, 0.3)");
        glow.addColorStop(1, "rgba(255, 100, 0, 0)");

        ctx.fillStyle = glow;
        ctx.beginPath();
        ctx.roundRect(innerX, innerY, innerW, innerH, cornerRadius);
        ctx.fill();

        // Glossy top highlight
        const shine = ctx.createLinearGradient(innerX, innerY, innerX, innerY + innerH / 2);
        shine.addColorStop(0, "rgba(255,255,255,0.45)");
        shine.addColorStop(1, "rgba(255,255,255,0)");
        ctx.fillStyle = shine;

        ctx.beginPath();
        ctx.roundRect(innerX, innerY, innerW, innerH / 2, cornerRadius);
        ctx.fill();
    };

    drawIconBackgroundImg = (ctx, x, y, width, height) => {
        const margin = 0;
        const cornerRadius = 0;

        const innerX = x + margin / 2;
        const innerY = y + margin / 2;
        const innerW = width - margin + 20;
        const innerH = height - margin + 20;

        // Draw image once it's loaded
        if (this.CreateBG.complete) {
            ctx.save();
            ctx.beginPath();
            ctx.roundRect(innerX, innerY, innerW, innerH, cornerRadius);
            ctx.clip();
            ctx.drawImage(this.CreateBG, innerX, innerY, innerW, innerH);
            ctx.restore();
        } else {
            this.CreateBG.onload = () => {
                ctx.save();
                ctx.beginPath();
                ctx.roundRect(innerX, innerY, innerW, innerH, cornerRadius);
                ctx.clip();
                ctx.drawImage(this.CreateBG, innerX, innerY, innerW, innerH);
                ctx.restore();
            };
        }
    };

    SpinControlDis = (resData) => {
        console.log(this.state.BetResponseCT)
        if (this.state.BetResponseCT?.bonuscount > 0) {
            if (this.state.BetResponseCT?.gameFinished == false) {
                if (!this.state.freeSpinsPopup) {
                    this.setState({
                        // freeSpinsPopup: true,
                        isSpinning: true
                    })
                }
                this.setState({
                    BonusActiveStatus: true
                })
                this.Howlersounds.current?.playSound("scatterWinS");
                this.Howlersounds.current?.playSound("bonusWin");
            } else {
                this.setState({
                    isSpinning: resData,
                    BetResponseCT: []
                })
            }
        } else {
            if (this.state.isAutoPlay) {
                this.setState({
                    isSpinning: true
                })
            } else {
                this.setState({
                    isSpinning: resData
                })
            }
            // this.setState({
            //     BetResponseCT: []
            // })
        }
    }
    pannelPayoutClick = (count, line) => {
        this.Howlersounds.current?.playSound("clickbtnS");
        // payoutlist1[count].active = true
        // const updatedList12 = payoutlist1
        // setpayoutlines(updatedList12); // Update state
        const newLineCount = count + 1;
        this.activelinesCount(newLineCount, line);
    }
    activelinesCount = (num, line) => {
        // const updatedList12 = payoutlist1.map((line, i) => ({
        //   ...line,
        //   active: i < num  // Make `active` true if index is less than num
        // }));
        const updatedList = [...this.state.UpdatedPayoutList]
        // updatedList[num - 1].active = !updatedList[num - 1].active
        if (line.active) {
            for (let i = updatedList.length - 1; i >= num; i--) {
                updatedList[i].active = false
            }
        } else {
            for (let i = 0; i < num; i++) {
                updatedList[i].active = true
            }
        }

        this.setState({
            UpdatedPayoutList: updatedList
        })
        console.log(this.state.UpdatedPayoutList)
        let NeeCountValue = updatedList.reduce((a, b) => a + Number(b.active), 0)
        this.setState(
            {
                linescount: NeeCountValue,
                anteamount: Number(this.chipVal[this.state.count - 1].val) * Number(NeeCountValue),
            })
    }

    setNewActiveLines = (type) => {
        let newLinesArray = [...this.state.UpdatedPayoutList];

        if (type === "INC") {
            let updated = false;
            newLinesArray = newLinesArray.map((ele) => {
                if (!updated && !ele.active) {
                    updated = true;
                    return { ...ele, active: true };
                }
                return ele;
            });
        } else if (type === "DEC") {
            for (let i = newLinesArray.length - 1; i >= 0; i--) {
                if (newLinesArray[i].active) {
                    newLinesArray[i] = { ...newLinesArray[i], active: false };
                    break;
                }
            }
        }
        // setpayoutlines(newLinesArray);
        this.setState({
            UpdatedPayoutList: newLinesArray
        })
    };

    menuChange = () => {
        this.Howlersounds.current?.playSound("clickbtnS");
        console.log(this.state.menuActive)

        this.setState({
            menuActive: !this.state.menuActive
        })
    }
    ClosePopupIB = () => {
        this.Howlersounds.current?.playSound("clickbtnS");
        this.setState({
            ErrorPopup: false
        })
    }

    updateplayerbalnace = () => {
        if (this.state.BonusActiveStatus) {

        } else {
            const body2 = {
                CN: "GET_PLAYER_INFO",
                // CN: "GET_UPDATED_PLAYER_INFO",
                object: {
                    gameId: Number(this.props.gameId,),
                    playerId: Number(this.props.playerId),
                },
                sessionId: sessionStorage.getItem('sessionId'),
            }
            this.props.network.sendof(body2);
            this.body2 = {};
        }

    }
    handleImageLoad = () => {
        const { assestsLoaderFunction } = this.props;
        assestsLoaderFunction()
    }

    closePopup = () => {
        this.Howlersounds.current?.playSound("clickbtnS");
        this.setState({
            payoutpayoutpopup: false,
            historyTablePopup: false
        });
    };


    handleDocumentClick = (event) => {
        /// payout table
        const dropdownElement = this.SideMenuRef.current;
        const infrmiconElement = document.getElementById("SidemenuBtnCT");

        const clickedInsideDropdown = dropdownElement && dropdownElement.contains(event.target);
        const clickedOnInfrmicon = infrmiconElement && infrmiconElement.contains(event.target);

        console.log(clickedInsideDropdown || clickedOnInfrmicon);

        if (!clickedInsideDropdown && !clickedOnInfrmicon) {
            if (this.state.menuActive) {
                this.setState({ menuActive: false });
            }
            console.log("enter...............................");
        }

    }
    FreeSpinsClosepopup = (showStatus) => {
        this.setState({
            freeSpinsPopup: false,
            BonusAnimateActive: true
        })
    }
    BonusClosepopup = (showStatus) => {
        this.setState({
            BonusAnimateActive: false,
            BetResponseCT: [],
            // isSpinning: false,
            BonusActiveStatus: false
        })
        this.getGameState()
    }

    BonusActive = (indexValue) => {
        if (this.props) {
            // console.log(this.props)
            // console.log(this.props.gameState)
            let SlotsBody = {
                sessionId: sessionStorage.getItem("sessionId"),
                CN: "CORSAIRS_TREASURE_BET",
                object: {
                    action: "MOVE_BET",
                    gameId: Number(this.props.gameId),
                    playerId: Number(this.props.playerId),
                    handId: Number(this.props.gameState.handId),
                    bonusindex: indexValue
                }
            }
            this.props.network.sendof(SlotsBody);
        }
    }
    BonusoneActive = () => {

    }
    BonusWinAnimate = () => {

    }
    muteSoundsChange = () => {
        this.setState(prev => ({
            mutesounds: !this.state.mutesounds
        }), () => {
            this.Howlersounds.current?.playSound("backgroundSoundS");
        }
        );

    }
    closeWin() {
        document.getElementById('iospopup').style.display = "none";

    }
    setBGSound = () => {
        this.Howlersounds.current?.playSound("backgroundSoundS");
    }
    checkHistoryData = () => {
        console.log(this.props.gameState)
        const history = this.props.gameState?.history ?? [];

        this.HistoryData = history.length
            ? history.map(item => {
                const result = item.result || {};

                return {
                    HistoryKeyData: [
                        { id: "HandId", value: result.handId },
                        { id: "Bet", value: result.betAmount },
                        { id: "Win", value: result.winAmount },
                        { id: "Bonus", value: result?.bonusWinAmount ? result?.bonusWinAmount : 0 }
                    ],

                    SlotsGrid: {
                        board: result.board || [],
                        winninglines: result.winninglines || []
                    }
                };
            })
            : [];
        console.log(this.HistoryData)

    }
    onCloseGameRulesPop = () => {
        this.setState({
            GameRulesPopup: false
        })
    }
    AutoPlayCountFRMSlotsEn = () => {
        this.setState((prevState) => ({
            ...prevState,
            autoPlayCount: prevState.autoPlayCount > 0 ? prevState.autoPlayCount - 1 : 0
        }))
    }
    AfterSpinHit = () => {
        console.log(this.state.BetResponseCT)
        if (this.state.BetResponseCT?.bonuscount > 0) {
            if (this.state.BetResponseCT?.gameFinished == false) {
                if (!this.state.freeSpinsPopup) {
                    this.setState({
                        freeSpinsPopup: true,
                        isSpinning: true
                    })
                }
                this.setState({
                    BonusActiveStatus: true
                })
                this.Howlersounds.current?.playSound("scatterWinS");
                this.Howlersounds.current?.playSound("bonusWin");
            }
        } else {
            this.setState({
                BetResponseCT: []
            })
        }
    }

    render() {
        const { count } = this.state;
        const chip = this.chipVal[count - 1]; // index starts from 0
        const isMin = count === 1;
        const isMax = count === this.chipVal.length;

        const iscountmin = this.state.linescount === 1;
        const iscountmax = this.state.linescount === 9;
        return (
            <>
                <Howlersounds ref={this.Howlersounds} mutesounds={this.state.mutesounds} />
                {this.state.payoutpayoutpopup && (<CorsairsPayOuttable Game_Icons={this.Game_Icons} onClose={this.closePopup} />)}
                {this.state.historyTablePopup && (<HistoryTable Game_Icons={this.Game_Icons} HistoryAllData={this.HistoryData} onClose={this.closePopup} />)}

                <div className="iosFetchSounds" id="iospopup" onClick={(e) => { this.setBGSound(); this.closeWin() }}>
                    <div className="popupTooLong">
                        <div className=""> {this.props.language.Wel_CT} </div>
                        <br></br>
                        {this.props.language.OK_Btn}
                        <br></br>
                        <br></br>
                        <div className="fd">
                            <button className="btn_iosPopup" onClick={(e) => this.setBGSound()}> {this.props.language.Ok} </button>
                            <br></br>
                        </div>
                    </div>
                </div>

                <div className="MainDivSlotBGCT">
                    <div className="logotittleCT">
                        <img src={logo} alt="" />
                    </div>
                    <button className="menu_RTDivCT" id="SidemenuBtnCT" onClick={() => { this.menuChange() }}>
                        <img src={menu} alt="" className="menu_CT" />
                    </button>
                    <div>
                        {
                            this.state.gamewins ?
                                <WinningAmount targetAmount={this.state.winAMT}
                                    setWinsAndAmount={this.setWinsAndAmount}
                                /> : ""
                        }
                    </div>
                    <div>
                        {
                            this.state.drawnLinesT ?
                                <WinLines Winsdata={this.state.drawnLinesresDate}
                                /> : ""
                        }
                    </div>
                    <div>
                        {
                            this.state.WinPulseRT && (
                                <WinPulse Winsdata={this.state.drawnLinesresDate} IndexWinsIcons={this.state.IndexWinningIcons}
                                />)
                        }
                    </div>
                    <div>
                        {
                            this.state.WinBGColorsRT && (
                                <WinBGColor Winsdata={this.state.drawnLinesresDate} IndexWinsIcons={this.state.IndexWinningIcons}
                                />)
                        }
                    </div>
                    <div >
                        {
                            this.state.freeSpinsPopup && (
                                <FreeSpins show={this.state.FreeSpinsBonus} FreeSpinsClosepopup={this.FreeSpinsClosepopup} ActiveCall={this.BonusoneActive} muteSoundStatus={this.state.mutesounds}
                                />)
                        }
                    </div>
                    <div >
                        {
                            this.state.BonusAnimateActive && (
                                <BonusAnimate ref={this.BonusAnimateRef}
                                    BonusBoxGameClosepopup={this.BonusClosepopup}
                                    muteSoundStatus={this.state.mutesounds}
                                    BonusActiveCall={this.BonusActive}
                                    winningBonusAmount={this.BonusWinAnimate}
                                    balanceCT={this.state.TotalBalance}
                                    userName={this.props.user}
                                />
                            )
                        }
                    </div>
                    <div className="Payout_main_DivCTM">
                        <div className='dis_por_topCT'>
                            {this.state.UpdatedPayoutList.slice(0, 9).map((line, i) => (
                                <button className='payOutLineBtnCT' style={{ display: "block" }} key={i}
                                    onClick={() => this.pannelPayoutClick(i, line)} disabled={this.state.isSpinning}
                                >
                                    <h1
                                        className={`payoutboxSFF1CT ${line.active ? 'linesCount_BGCTM' : ''}`}>
                                        {line.linesCount}
                                    </h1>
                                </button>
                            ))}
                        </div>
                        <div className="SlotsEngineMainCT">
                            <div className="FrameImgCon">
                                {/* <div className="FrameImgCon deskTp_view_frame"> */}
                                <img src={Frame} className="windows_frame_img" />
                            </div>
                            {/* <div className="FrameImgCon_mobile Mobile_view_frame">
                                <img src={Mobile_Frame} className="mobile_frame_img"/>
                            </div> */}
                            <Slotsanimation
                                ref={this.Slotsanimation}
                                gameId={this.props.gameId}
                                playerId={this.props.playerId}
                                handId={this.props.gameState.handId}
                                balance={this.props.balance}
                                betamount={this.state.anteamount}
                                chipcount={this.state.chipcount}
                                autoPlayCount={this.state.autoPlayCount}
                                setAutoPlayCount={this.AutoPlayCountFRMSlotsEn}
                                // setAutoPlayCount = {(num) => {
                                //     this.setState({ autoPlayCount: num })
                                // }}
                                setWinsAndAmount={this.setWinsAndAmount}
                                getGameState={this.getGameState}
                                // createLineMain={this.CreateRetroLines}
                                CreateWinAnimateLines={this.CreateWinAnimationsData}
                                SetSpinDisable={this.SpinControlDis}
                                createBGColors={this.CreateRetroLines}
                                updateplayerbalnace={this.updateplayerbalnace}
                                GameType={"CorsairsTreasure"}
                                Reels={5}
                                SpinDirection={'down'}
                                AfterSpinHit={this.AfterSpinHit}
                            />
                        </div>
                        <div className='dis_por_bottomCT'>
                            {
                                this.state.UpdatedPayoutList.slice(0, 9).map((lines, i) => {
                                    return (
                                        <button className='payOutLineBtnCT' key={i} style={{ display: "block" }}
                                            onClick={() => this.pannelPayoutClick(i, lines)} disabled={this.state.isSpinning} >
                                            <h1 className={`payoutboxSFF2CT ${lines.active ? "linesCount_BGCTM" : ''}`}>
                                                {lines.linesCount}</h1>
                                        </button>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className="main_disply_centerCT topsectopnMBmodeCT">
                        <div className="balancewinsectionCT">
                            <div className="balance_winDivCT">
                                <div className="text-center balance_section">
                                    <img src={balance} alt="" className="imgbtnCT upsectionCT" />
                                    <p className="amt_numCT">{this.state.TotalBalance.toFixed(2)}</p>
                                    {/* <p className="amt_numCT transfr_downCT">{this.state.TotalBalance.toFixed(2)}</p> */}
                                </div>
                                <div></div>
                                <div className="btwn_space_bln">
                                    <div className="text-center balance_section">
                                        <img src={win} alt="" className="imgbtnCT upsectionCT" />
                                        <p className="amt_numCT">{this.state.win_amount}</p>
                                        {/* <p className="amt_numCT transfr_downCT">{this.state.win_amount}</p> */}
                                    </div>
                                    <div className="text-center balance_section">
                                        <img src={profile} alt="" className="imgbtnCT upsectionCT" />
                                        <p className="amt_numCT">{this.props.user}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="balancewinsectionCT btm_positionCT">
                        <div className="main_disply_centerCT">
                            <div className="clearbetbtnCT">
                                {/* <img src={clear} alt="" className="imgbtnCT" /> */}
                                <div className="betamvalueCT">
                                    <p className="amt_numCT BTN_Nms_psn_CT BET_Ydrn_CT">{this.props.language.Bet}</p>
                                    <p className="amt_numCT tns_position_betCT">{this.state.anteamount}</p>
                                    <img src={bet} alt="" className="imgbtnCT" />
                                </div>
                                {/* <div> */}
                                <div className="mainchipdiv_linescountCT">
                                    <p className="amt_numCT BTN_Nms_psn_CT Lines_Ydrn_CT">LINES COUNT</p>
                                    <img src={bet} alt="" className="imgbtnCT" />
                                    <div className="RT_linesCountDivCT">

                                        <button
                                            disabled={iscountmin || this.state.isSpinning}
                                            className={`${iscountmin ? "icon_opacity" : ""}`}
                                            onClick={this.Decreamentlinescount}
                                        >
                                            <h1 className=" amt_numCT">-</h1>
                                        </button>
                                        <p className="amt_numCT" style={{ cursor: "pointer" }} onClick={this.OpenPayoutTable}>
                                            {this.state.linescount}
                                        </p>
                                        <button
                                            disabled={iscountmax || this.state.isSpinning}
                                            className={`${iscountmax ? "icon_opacity" : ""}`}
                                            onClick={this.Increamentlinescount}
                                        >
                                            <h1 className=" amt_numCT" >+</h1>
                                        </button>

                                    </div>

                                </div>
                                {/* </div> */}
                            </div>


                            <div className="mainchipdivCT">
                                <button
                                    disabled={isMin || this.state.isSpinning}
                                    className={`decreaechipbtnCT ${isMin ? "icon_opacity" : ""}`}
                                    onClick={this.DecreamentBetchips}
                                >
                                    <img src={betincerementdecrement} alt="Decrease Chip" className="img_IN_DE_WCT" />
                                </button>

                                <div className="chip-displayCT">
                                    <div className="retro-chipsCT" style={{ "--selectedIndex": count - 1 }}>
                                        <Chips gameChips={this.props.os_chipValues} selectedChipIndex={count - 1}></Chips>
                                    </div>
                                    <img src={circlechip} alt="chipcircle" className="chipcirclecsCT" />
                                </div>
                                <button
                                    disabled={isMax || this.state.isSpinning}
                                    className={`${isMax ? "icon_opacity" : ""}`}
                                    onClick={this.IncreamentBetchips}
                                >
                                    <img src={betincerementdecrement} alt="Increase Chip" className="img_IN_DE_WCT" />
                                </button>
                            </div>


                            <div className="mainbtn12CT">
                                {/* <img src={freespins} alt="" className="imgbtnCT" /> */}
                                {/* <button id="autoPlayBtnFF" disabled={this.state.isSpinning}>
                                <p className="amt_numCT">FREE SPIN</p>
                            </button> */}
                                <button id="autoPlayBtnCT" className={`${this.state.isAutoPlay ? "autoPlayActiveCT" : ""}`} onClick={this.handleAutoPlayClick} disabled={!this.state.isAutoPlay && this.state.isSpinning}>
                                    <img src={AutoPlayBtn} alt="Spin" className="imgbtnspin imgbtnCT" />
                                    <p className="amt_numCT Auto_paraCT">AUTO {this.state.autoPlayCount ? ": " + this.state.autoPlayCount : "PLAY"}</p>
                                </button>
                                {/* <img onClick={() => { this.setState((prevState) => ({ ...prevState, showAutoPlayOptions: !prevState.showAutoPlayOptions })) }} src={autoplay} alt="" className="imgbtnCT" /> */}

                                <button className="SpinbtnFruityCT" onClick={this.spinaction} disabled={this.state.isSpinning}>
                                    <img src={spinbtn} alt="Spin" className="imgbtnspin imgbtnCT" />
                                    <p className="Spin_paraCT">{this.props.language.Spin}</p>
                                </button>
                            </div>


                        </div>
                    </div>
                    {this.state.PayoutTableShow &&
                        <div className="">
                            <div onClick={this.ClosePayoutTable} className="autoOptionsCoverBackCT" style={{ cursor: "pointer" }} ></div>
                            <div className={`paylines-overlayCTM payoutTableMainDivCTM ${this.state.PayoutTableShow ? 'openTable' : ''}`}>
                                <div className="paylines-boxCTM">
                                    <h2 className="titleCTM">LINES</h2>
                                    <p className="line_changesCTM"></p>
                                    <div className="paylines-gridCTM">
                                        {this.paylines.map((line) => {
                                            const points = line.positions
                                                .map((row, col) => {
                                                    const x = col * this.cellSize + this.cellSize / 2;
                                                    const y = row * this.cellSize + this.cellSize / 2;
                                                    return `${x},${y}`;
                                                })
                                                .join(" ");

                                            return (
                                                <div key={line.id} className="line-boxCTM">
                                                    <div className="line-numCTM">{line.id}</div>
                                                    <svg
                                                        width={this.cellSize * this.cols}
                                                        height={this.cellSize * this.rows}
                                                        className="payline-svgCTM"
                                                    >
                                                        {/* Draw background grid */}
                                                        {[...Array(this.rows)].map((_, r) =>
                                                            [...Array(this.cols)].map((_, c) => {
                                                                const isHighlighted = line.positions[c] === r;
                                                                return (
                                                                    <rect
                                                                        key={`${r}-${c}`}
                                                                        x={c * this.cellSize}
                                                                        y={r * this.cellSize}
                                                                        width={this.cellSize}
                                                                        height={this.cellSize}
                                                                        fill={isHighlighted ? this.activeColor : this.inactiveColor}
                                                                        stroke="#333"
                                                                        strokeWidth="1"
                                                                    />
                                                                );
                                                            })
                                                        )}

                                                        {/* Draw line through selected cells */}
                                                        <polyline
                                                            points={points}
                                                            fill="none"
                                                            stroke={this.lineColor}
                                                            strokeWidth="4"  // 🔹 bold like Hawaiian Waves
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />

                                                        {/* Draw dots on path */}
                                                        {line.positions.map((row, col) => (
                                                            <circle
                                                                key={col}
                                                                cx={col * this.cellSize + this.cellSize / 2}
                                                                cy={row * this.cellSize + this.cellSize / 2}
                                                                r="2"
                                                                fill="#470461c7"
                                                                stroke={this.lineColor}
                                                                strokeWidth="1"
                                                            />
                                                        ))}
                                                    </svg>
                                                </div>
                                            );
                                        })}
                                    </div>

                                </div>
                            </div>
                        </div>
                    }


                    {this.state.showAutoPlayOptions && <div className="autoOptionsCoverBackCT"><div className="autoPlayOptionsCT">
                        <h1 className="amt_numCT">{this.props.language.Auto_Play}</h1>
                        <button onClick={() => { this.setState({ showAutoPlayOptions: false, autoPlayCount: 0 }); this.Howlersounds.current?.playSound("clickbtnS"); }} className="autoPlayCloseBtnCT" style={{ background: `url(${closeBtn})`, height: "61px", width: "61px", backgroundSize: "cover" }}></button>
                        {/* <img onClick={() => { this.setState({ showAutoPlayOptions: false }) }} src={closeBtn} className="autoPlayCloseBtnCT" /> */}
                        <div className="displayAutoOptionsCT">
                            {this.state.autoPlayOptions.map((ele, ind) =>
                                <button
                                    className={`autoPlayNumbersCT${ele === this.state.autoPlayCount ? " selectedAutoPlayOptionCT" : ""}`}
                                    disabled={ele === this.state.autoPlayCount}
                                    onClick={() => { this.setState({ autoPlayCount: ele }); this.Howlersounds.current?.playSound("clickbtnS"); }} key={ind}>
                                    <p>{ele}</p>
                                </button>)}
                        </div>
                        <div className="displayAutoOptionsCT">
                            <button className="autoPlayNumbersCT cancelBtnCT" disabled={!this.state.autoPlayCount} onClick={() => { this.setState({ autoPlayCount: 0 }); this.Howlersounds.current?.playSound("clickbtnS"); }}><p>CLEAR</p></button>
                            <button className="autoPlayNumbersCT playBtnCT" disabled={!this.state.autoPlayCount} onClick={this.handleAutoPlayClick}><p>PLAY</p></button>
                        </div>
                    </div>
                    </div>}

                    {this.state.showCancelAutoPlay && <div className="autoOptionsCoverBackCT">
                        <div className="autoPlayOptionsCT">
                            <h1 className="amt_numCT">Are You Sure To Stop Auto Play?</h1>
                            <div className="displayAutoOptionsCT">
                                <button
                                    className={`autoPlayNumbersCT`}
                                    onClick={this.stopAutoPlay}>
                                    <p>YES</p>
                                </button>
                                <button
                                    className={`autoPlayNumbersCT`}
                                    onClick={this.restartAutoPlay}>
                                    <p>NO</p>
                                </button>
                            </div>
                        </div>
                    </div>}
                    {
                        this.state.menuActive &&
                        <div className="MenuMainDivCT">
                            <ul>
                                <li onClick={() => { this.setState({ payoutpayoutpopup: true }); this.Howlersounds.current?.playSound("clickbtnS"); }}>Pay Table </li>
                                <li onClick={() => { this.setState({ GameRulesPopup: true }); this.Howlersounds.current?.playSound("clickbtnS"); }}>Help</li>
                                <li onClick={() => { this.setState({ historyTablePopup: true }); this.Howlersounds.current?.playSound("clickbtnS"); }}>History</li>
                            </ul>
                        </div>
                    }
                    {
                        this.state.ErrorPopup && <div className="frameCT">
                            <div className="modalCT">
                                <div>
                                    <img src="https://100dayscss.com/codepen/alert.png" width="44" height="38" />
                                    {/* <span className="title">insufficient balance!</span>
                                    <p>You have insufficient balance for the bet.</p> */}

                                    <span className="title">{this.state.ErrorMsgHead}</span>
                                    <p>{this.state.ErrorMsg}</p>
                                    {/* <div onClick={() => {
                                        this.ClosePopupIB()
                                    }} className="button">X</div> */}
                                </div>
                                <button className="ClosePop_btn_inBln" onClick={() => { this.ClosePopupIB() }}>
                                    <span class="ClosePop_btn_inBln_shadow"></span>
                                    <span class="ClosePop_btn_inBln_edge"></span>
                                    <span class="ClosePop_btn_inBln_front text"> Ok
                                    </span>
                                </button>
                            </div>
                        </div>
                    }
                    <div onClick={() => { this.setState({ payoutpayoutpopup: true }); this.Howlersounds.current?.playSound("clickbtnS"); }} className="Payout_i_icon">
                        <img src={i_icon} alt="" className="w_h_pay_vlm" />
                    </div>
                    <div onClick={this.muteSoundsChange} className="volume_i_icon">
                        <img src={this.state.mutesounds ? mute_sound : Valume} alt="" className="w_h_pay_vlm" />
                    </div>

                    <div className="player_hand_ids">
                        <div className="sub_div_p_h">
                            <h5 className="sub_head_p_h">{this.props.language.Hand_Id} &nbsp; &nbsp;: <span>{this.props.gameState.handId}</span> </h5>
                            <h5 className="sub_head_p_h">{this.props.language.Player_Id} : <span>{this.props.playerId}</span> </h5>
                        </div>
                    </div>

                    {/* <div className="Min_Max_ids">
                        <div className="sub_div_p_h">
                            <h5 className="sub_head_p_h">MIN &nbsp; : <span>{this.props.minBetAmt}</span> </h5>
                            <h5 className="sub_head_p_h">MAX : <span>{this.props.maxBetAmt}</span> </h5>
                        </div>
                    </div> */}
                    <div className="Turbo_main_div">
                        <button
                            className={`turbo-slot-btn ${this.state.turboActive ? "active" : "inactive"}`}
                            onClick={() => {
                                this.setState(prev => ({
                                    turboActive: !prev.turboActive
                                }))
                            }} disabled={this.state.isSpinning}
                        >
                            <div className="turbo-ring"></div>

                            <div className="turbo-icon">⚡</div>

                            <div className="turbo-slash"></div>

                            <div className="turbo-text">TURBO</div>
                        </button>
                    </div>

                    {
                        this.state.GameRulesPopup && <div className="Game_rules_main_div">
                            <button className="closebtn_Game_cl" onClick={this.onCloseGameRulesPop}>
                                <img src={closeBtn} />
                            </button>
                            <div className="Game_rules_subDiv">
                                <div className="GameRule_head">
                                    <h1 className="Game_head">Game Rules</h1>
                                    <p className="GameRules_Line"></p>
                                </div>
                                <ul className="">
                                    {this.GamesRules.map((rule, i) => (
                                        <li className="GameR_list">
                                            {rule.rules}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    }

                </div>

            </>);
    }
}

const mapStatesToProps = (state) => {
    return {
        language: state.languageObjs.languageObj
    }
}

export default connect(mapStatesToProps)(CorsairsTreasure)



